module.exports = __webpack_public_path__ + "static/media/speaker2.1fe87dde.png";